import { render, staticRenderFns } from "./cAdminAtlasWorkflows.vue?vue&type=template&id=b0dfb00a&scoped=true"
import script from "./cAdminAtlasWorkflows.vue?vue&type=script&lang=js"
export * from "./cAdminAtlasWorkflows.vue?vue&type=script&lang=js"
import style0 from "./cAdminAtlasWorkflows.vue?vue&type=style&index=0&id=b0dfb00a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0dfb00a",
  null
  
)

export default component.exports